import { render, staticRenderFns } from "./FormNormalUpload.vue?vue&type=template&id=07ce3a06&scoped=true&"
import script from "./FormNormalUpload.vue?vue&type=script&lang=js&"
export * from "./FormNormalUpload.vue?vue&type=script&lang=js&"
import style0 from "./FormNormalUpload.vue?vue&type=style&index=0&id=07ce3a06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ce3a06",
  null
  
)

export default component.exports